import {useCallback} from "react";
import {deleteSubmit, getSubmit, postSubmit} from "@ui-seeker/utils";
import {BACKEND_APIS, SERVICES_TYPE} from "@constants";
import {
    isEditUserSettingsSitesGroupDrawer,
    isLoadingUserSettingSitesGroupData,
    userSettingSitesGroupData,
    userSettingsSitesGroupFormData
} from "../@signals";
import {useToastSeeker} from "@app";
import {useSignal} from "@preact/signals-react";

export default function useSitesGroup(rowData={}) {
    const { showToast } = useToastSeeker()
    const isLoading = useSignal(false)

    const getSitesGroupData = useCallback(() => {
        getSubmit(`${BACKEND_APIS.CRUD}/user/sites_group`)
            .then(data => userSettingSitesGroupData.value = data)
            .catch(() => {
                showToast.error()
                userSettingSitesGroupData.value = []
            }).finally(() => isLoadingUserSettingSitesGroupData.value = false)
    }, [])

    const handleSetSitesGroupFormData = useCallback(() => userSettingsSitesGroupFormData.value = {
        id: rowData.id || null,
        service_type: SERVICES_TYPE.SITE_GROUP,
        name: rowData.name || "My Site Group",
        sites: rowData.sites || []
    }, [JSON.stringify(rowData)])

    const handleChangeSitesGroupFormData = useCallback((newValue, prop) => userSettingsSitesGroupFormData.value = {
        ...userSettingsSitesGroupFormData.value,
        [prop]: newValue
    }, [])

    const handleSubmitSitesGroupFormData = useCallback(() => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsSitesGroupDrawer.value ? 'add' : 'update'}`, userSettingsSitesGroupFormData.value).then(res => {
            if (isEditUserSettingsSitesGroupDrawer.value) {
                userSettingSitesGroupData.value = [
                    ...userSettingSitesGroupData.value.map(item => item.id === userSettingsSitesGroupFormData.value.id ? res : item),
                ]
            }else{
                userSettingSitesGroupData.value = [
                    ...userSettingSitesGroupData.value,
                    res
                ]
            }
            userSettingsSitesGroupFormData.value = {}
        }).catch(() => showToast.error())
            .finally(() => isLoading.value = false)
    }, [])
    const handleDeleteSitesGroup = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
        onSubmit: () => {
            isLoading.value = true
            deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.SITE_GROUP}?id=${rowData.id}`).then(() => {
                userSettingSitesGroupData.value = [
                    ...userSettingSitesGroupData.value.filter(item => item.id !== rowData.id)
                ]
            }).catch(() => showToast.error())
                .finally(() => isLoading.value = false)
        }
    }), [JSON.stringify(rowData)])

    return {
        isClicked: rowData.id === userSettingsSitesGroupFormData.value.id,
        isLoading: isLoading.value,
        getSitesGroupData,
        handleSetSitesGroupFormData,
        handleChangeSitesGroupFormData,
        handleSubmitSitesGroupFormData,
        handleDeleteSitesGroup
    }
}